import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../utils/authUtils';
import { getCurrentUserProfilePhoto, getCurrentCustomerName, setupProfilePhotoListener, getDeceasedPersonDate, getDeceasedPersonProfileText } from '../../../utils/profilePhotoUtils';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import { IoEyeOutline } from "react-icons/io5";
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';



// Separate component for album image card
const AlbumImageCard = ({ album, formatDate, onAlbumClick }) => {
  const imageUrl = album.thumbUrl || album.photoUrl;
  
  
  return (
    <div 
      className="memorial-album-board-list-image-card"
      onClick={() => onAlbumClick(album)}
      style={{ cursor: 'pointer' }}
    >
      <div className="memorial-album-board-list-image-container">
        <img 
          src={imageUrl}
          alt={album.title || "앨범 이미지"}
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
        />
      </div>
      <div className="memorial-album-board-list-image-info">
        <h4>{album.title || "제목 없음"}</h4>
        <p>{formatDate(album.registTime)}</p>
        <div className="memorial-album-board-list-views-container">
        <div className="memorial-album-board-list-views-icon">
        <IoEyeOutline />
        </div>
        <div>
        <span className="memorial-album-board-list-views">{album.readCount || 0}</span>
        </div>
        </div>
      </div>
    </div>
  );
};

const MemorialAlbumBoardListPC = () => {
  const navigate = useNavigate();
  const handleNavigation = (route) => { navigate(route); };

  // State for album data
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/donate/layer-1910.png');
  const [displayedAlbums, setDisplayedAlbums] = useState([]);
  const [hasMoreAlbums, setHasMoreAlbums] = useState(false);
  const [albumsPerPage] = useState(9);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  var sorted;
  var sortedAlbumIds; 

  
 
 
  // Load memorial albums using CyberMemorialService and set displayedAlbums (DonatePC-style pagination)
  useEffect(() => {
    const loadAlbums = async () => {
      try {
        const selectedPersonData = localStorage.getItem('selectedPersonData');
        const personData = selectedPersonData ? JSON.parse(selectedPersonData) : null;
        const goinId = personData?.goinId;
        if (!goinId) {
          setAlbums([]);
          setDisplayedAlbums([]);
          setHasMoreAlbums(false);
          setTotalItems(0);
          setTotalPages(0);
          setCurrentPage(1);
          setLoading(false);
          return;
        }

        setLoading(true);
        const response = await CyberMemorialService.getMemorialAlbumList(goinId, 1, 200);
        const rawAlbums = Array.isArray(response?.albums) ? response.albums : [];
        const mapped = rawAlbums.map(a => ({
          albumId: a.albumId,
          title: a.albumTitle || '제목 없음',
          thumbUrl: a.photoThumbUrl || a.photoUrl || '/gallery pc list/p-5070484.png',
          photoUrl: a.photoUrl || '/gallery pc list/p-5070484.png',
          readCount: a.readCount || 0,
          registTime: a.registTime || new Date().toISOString(),
          customerName: a.customerName || 'default'
        }));
        sorted = mapped.sort((a, b) => new Date(b.registTime) - new Date(a.registTime));
        setAlbums(sorted);
        const total = Number(response?.totalItems) || sorted.length;
        setTotalItems(total);
        const firstPage = sorted.slice(0, albumsPerPage);
        setDisplayedAlbums(firstPage);
        setHasMoreAlbums(sorted.length > albumsPerPage);
        setCurrentPage(1);
        setTotalPages(Math.ceil(sorted.length / albumsPerPage));
      } catch (e) {
        setAlbums([]);
        setDisplayedAlbums([]);
        setHasMoreAlbums(false);
        setTotalItems(0);
        setTotalPages(0);
      } finally {
        setLoading(false);
      }
    };
    loadAlbums();
  }, [albumsPerPage]);


  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}.${month}.${day}`;
  };

  // Handle album click - navigate to article details
  const handleAlbumClick = async (album) => {
    try {
 
      // Fetch detailed album data from API
      const response = await CyberMemorialService.getMemorialAlbumDetail(album.albumId);
      
      if (response) {
        const idsInView = displayedAlbums.map(a => a.albumId);
       
        // Navigate to the article details page with detailed album data from API
         navigate('/memorial-album-article-details', { 
           state: { 
             albumData: {
               albumId: response.albumId || album.albumId,
               title: response.albumTitle || album.title,
               date: formatDate(response.registTime || album.registTime),
               image: response.photoUrl ||  response.photoThumbUrl || album.thumbUrl || album.photoUrl,
               readCount: response.readCount,
               customerName: response.customerName || album.customerName,
           
               photoThumbUrl: response.photoThumbUrl,
               registTime: response.registTime,
               cherishId: response.cherishId,
               goinId: response.goinId
             }, 
             sortedAlbumIds: idsInView
           }
         });
      } 
     
    } catch (error) {
      console.error('Error fetching album details:', error);
      
     
    }
  };



  // Handle load more albums
  const handleLoadMore = () => {
    if (!hasMoreAlbums) return;
    const nextPage = currentPage + 1;
    const startIndex = (nextPage - 1) * albumsPerPage;
    const endIndex = startIndex + albumsPerPage;
    const nextBatch = albums.slice(startIndex, endIndex);
    if (nextBatch.length > 0) {
      setDisplayedAlbums(prev => [...prev, ...nextBatch]);
      setCurrentPage(nextPage);
      setHasMoreAlbums(endIndex < albums.length);
    }
  };

  // Handle write button click
  const handleWriteClick = () => {
    // Check modal authentication status first
    if (checkModalAuthenticationStatus()) {
      navigate('/memorial-album-writing');
    } else {
      // Show authentication modal first
      setShowAuthModal(true);
    }
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // Navigate to writing page after successful authentication
    navigate('/memorial-album-writing');
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handleProfilePhotoUpload = (photoUrl) => {
    console.log('Photo uploaded, updating profile photo:', photoUrl.substring(0, 50) + '...');
    // Update profile photo immediately when photo is uploaded
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-album-board-list-pc page-memorial-album-board-list-pc announcement-list-page cyber-info-page-pc">
      
      <FamilyPlazaTopSection />
  
     <main className="main-content">
  
      <FamilyPlazaSubHeading heading="사이버추모관" />

      {/* Main Content */}
      <div className="memorial-album-board-list-main-content">
        <div className="memorial-album-board-list-page-content">
          <div className="memorial-album-board-list-container">
            

            <DeceasedPersonProfile 
              handlePhotoIconClick={handlePhotoIconClick}
            />

            {/* Action Tabs Navigation */}
            <div className="memorial-album-board-list-action-tabs">
              <div className="memorial-album-board-list-action-tabs-container">
                <ul>
                  <li><Link to="/donate">헌화하기</Link></li>
                  <li><Link to="/memorial-post-board-list">추모글</Link></li>
                  <li><Link to="/memorial-album-board-list" className="active">추모앨범</Link></li>
                </ul>
              </div>
            </div>

            {/* Content Area - Album Board List */}
            <div className="memorial-album-board-list-content-area">
              
              {/* Loading State */}
              {loading && (
                <div className="memorial-album-board-list-loading">
                  <p>앨범을 불러오는 중...</p>
                </div>
              )}

              {/* Error State */}
              {error && (
                <div className="memorial-album-board-list-error">
                  <p>오류가 발생했습니다: {error}</p>
                </div>
              )}

              {/* Image Grid */}
              {!loading && !error && (
                <div className="memorial-album-board-list-image-grid">
                  {displayedAlbums.map((album) => (
                    <AlbumImageCard
                      key={album.albumId}
                      album={album}
                      formatDate={formatDate}
                      onAlbumClick={(album) => handleAlbumClick(album)}
                    />
                  ))}
                </div>
              )}
              
              {/* More Button */}
              {!loading && !error && (
                <div className="memorial-album-board-list-more-section">
                  <button onClick={handleLoadMore} className="memorial-album-board-list-more-btn">
                    더보기
                  </button>
                </div>
              )}
              
              {/* Bottom Action Bar */}
              <div className="memorial-album-board-list-bottom-action">
                <div className="memorial-album-board-list-checkbox-container">
                  <img src="/images/icon4.png" alt="Check" className="letter-to-heaven-board-list-check-icon" />
                  <label htmlFor="memorial-album-checkbox" className="memorial-album-board-list-checkbox-label">
                    그리고 보고싶은 사람에게 추모앨범을 남겨주세요.
                  </label>
                </div>
                <button onClick={handleWriteClick} className="memorial-album-board-list-write-btn">글쓰기</button>
              </div>
              
            </div>

          </div>
        </div>
      </div>

      

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Portrait Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handleProfilePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialAlbumBoardListPC; 